module.exports = __webpack_public_path__ + "static/media/Magmortar_gaussian2.b28c022a.png";